export class FetchCriteriaModel {
  limit:number;
  offset:number;
  sortDir:string;
  sortField:string;
  searchValue:string;
  filteredCols:string;
}
